//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('productMultiUnit', {
//        templateUrl: 'views/components/views/productMultiUnit/productMultiUnit.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'utilityService', 'translateService', 'modalService', 'productMultiUnitService', 'logisticService', 'productUnitsService', function ($stateParams, stateService, utilityService, translateService, modalService, productMultiUnitService, logisticService, productUnitsService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let prodId = $stateParams.prod_id

//            let translations = {
//                error: '',
//                ok: ''
//            };

//            vm.model = {
//                edit: {},
//                selectListUnits: [],
//                selectListProductUnits: [],
//                lockedSave: false
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region TRANSLATION FUNCTION

//            async function translate() {
//                let data = await translateService.translateBatch(translations);

//                Object.keys(translations).forEach((key) => {
//                    if (data?.[key]) translations[key] = data[key];
//                });
//            }

//            // #endregion TRANSLATION FUNCTION

//            // #region LOAD PROCEDURE CALLS

//            async function loadEdit() {
//                vm.model.edit = (await productMultiUnitService.getEdit({ prod_id: prodId }))[0];

//                return loadProductUnits();
//            }

//            async function loadUnits() {
//                vm.model.selectListUnits = await logisticService.listUnits({ isactive: '1' });
//            }
            
//            async function loadProductUnits() {
//                if (utilityService.validateParmsValue(vm.model.edit.prod_id) !== true) return;

//                return vm.model.selectListProductUnits = await productUnitsService.listProductUnits({ prod_id: vm.model.edit.prod_id });
//            }

//            // #endregion LOAD PROCEDURE CALLS

//            // #region BUTTON SAVE PROCEDURE FUNCTION CALL

//            vm.saveChanges = function () {
//                vm.model.lockedSave = true;

//                productMultiUnitService.saveObj(vm.model.edit).then(function (response) {
//                    if (response[0].errorcode !== '0') {
//                    	modalService.show({
//                    		type: 'warning',
//                    		title: translations.error,
//                    		message: response[0].errormessage,
//                    		buttons: [{
//                    			label: translations.ok,
//                    			cssClass: 'btn-warning',
//                    			action: function (dialogItself) {
//                    				dialogItself.close();
//                    				vm.model.lockedSave = false;
//                    			}
//                    		}]
//                    	});
//                    } else {
//                    	vm.model.lockedSave = false;
//                    	stateService.back();
//                    }
//                });
//            };

//            // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//                translate();
//                loadEdit();
//                loadUnits();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
